var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-3 py-2 pointer-cursor hovered-background"},[(_vm.icon)?_c('span',{staticClass:"icon is-small mr-2"},[_c('i',{class:("fas fa-" + _vm.icon)})]):_vm._e(),_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }